import { Coins } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "../Reveal";

const COINS = [
  { label: "BTC", color: "#F7931A", size: 170, top: "-60px", right: "140px", delay: "0s" },
  { label: "ETH", color: "#627EEA", size: 120, top: "180px", right: "60px", delay: "1s" },
  { label: "USDT", color: "#26A17B", size: 110, top: "240px", right: "190px", delay: "2s", testId: "jb-usdt" },
];

function CoinOrb({ label, color, size, style, testId }) {
  return (
    <div
      className="absolute rounded-full grid place-items-center font-bold text-white shadow-xl cm-float"
      style={{
        width: size,
        height: size,
        background: `linear-gradient(135deg, ${color}, ${color}dd)`,
        ...style,
      }}
      data-testid={testId}
    >
      <span className="text-lg">{label}</span>
    </div>
  );
}

export default function JoinBanner() {
  return (
    <section className="py-12 lg:py-16 bg-white" data-testid="join-banner">
      <div className="cm-container">
        <Reveal
          variant="zoom-soft"
          duration={1100}
          className="relative rounded-[28px] lg:rounded-[32px] overflow-hidden px-8 lg:px-16 py-16 lg:py-20 cm-landing-cta-band"
        >
          <div
            className="absolute inset-0 opacity-[0.07] pointer-events-none"
            style={{
              backgroundImage:
                "radial-gradient(circle at 2px 2px, white 1px, transparent 0)",
              backgroundSize: "28px 28px",
            }}
          />
          <Reveal variant="fade-right" delay={200} className="relative text-white max-w-[640px] z-10">
            <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full bg-white/10 border border-white/20 text-[11px] font-bold tracking-widest uppercase">
              <Coins size={16} />
              <span>CoinMBX</span>
            </div>
            <h2 className="text-[30px] sm:text-[38px] lg:text-[48px] font-extrabold leading-[1.1] tracking-tight">
              Join a new generation of traders
            </h2>
            <p className="mt-4 text-white/80 text-[15px] max-w-[480px] leading-relaxed">
              Spot and institutional OTC — on web today. Install the Android app from our
              download page (direct APK).
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link
                to="/register"
                data-testid="join-get-started"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-cm-blue font-bold text-[14px] hover:shadow-lg hover:-translate-y-0.5 transition-all shadow-md"
              >
                Sign up free
              </Link>
              <Link
                to="/download"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border border-white/40 text-white font-semibold text-[14px] hover:bg-white/10 transition-all"
                data-testid="join-download-app"
              >
                Download app
              </Link>
            </div>
          </Reveal>

          <div className="hidden lg:block absolute top-0 right-0 bottom-0 w-[440px] pointer-events-none">
            {COINS.map((c) => (
              <CoinOrb
                key={c.label}
                label={c.label}
                color={c.color}
                size={c.size}
                style={{ top: c.top, right: c.right, animationDelay: c.delay }}
                testId={c.testId || `jb-${c.label.toLowerCase()}`}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
